import React, { useMemo, type Node } from 'react';
import { withRouter } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useSelector, shallowEqual } from 'react-redux';
import path from 'ramda/es/path';

import PlainNav, { NavItem } from 'app/common/ui/PlainNav';
import * as orgsTypes from 'app/common/constants/schools/types';
import { createPath, dnevnikPathMask, journalPathMask } from 'app/pages/routePaths';
import getTranslateIdWithOrgTypePrefix from 'app/components/Apps/Dnevnik/i18n/getTranslateIdWithOrgTypePrefix';


type Props = {
  studentId: string,
  params: Object,
}

const Nav = ({ studentId, params }: Props): Node => {
  const { t } = useTranslation('dnevnik');

  const [dnevnikPath, journalPath] = useMemo(() => ([
    createPath(params, dnevnikPathMask),
    createPath(params, journalPathMask),
  ]), [params]);

  const currentOrgType: $Values<typeof orgsTypes> = useSelector(
    path(['students', 'data', studentId, 'orgType']),
    shallowEqual
  );

  return (
    <PlainNav>
      <NavItem to={dnevnikPath}>
        {/* Дневник / Зачетка */}
        {t(getTranslateIdWithOrgTypePrefix('dnevnik_menu_item', currentOrgType))}
      </NavItem>

      <NavItem to={journalPath}>
        {/* Журнал */}
        {t('journal_menu_item')}
      </NavItem>
    </PlainNav>
  );
};

export default withRouter(Nav);
